import { Link } from "react-router-dom";
import { Heart, Sparkles, Gem, Crown } from "lucide-react";

// Visual cheat-sheet: how many roses to give by occasion.
// Price-agnostic on purpose so it can be reused across all "rozy-*" city articles.
const CONTENT = {
  ru: {
    title: "Сколько роз подарить — шпаргалка по поводу",
    subtitle: "Количество роз — это язык. Вот как его читают.",
    cta: "Собрать букет роз",
    cards: [
      { qty: "15–25", label: "Знак внимания", desc: "«Просто так», свидание, ужин. Лёгкий и изящный жест." },
      { qty: "51", label: "Романтика", desc: "Признание, годовщина, извинение. Самый популярный размер." },
      { qty: "101", label: "Большой жест", desc: "Помолвка, юбилей свадьбы, важный сюрприз." },
      { qty: "151+", label: "Wow-эффект", desc: "Предложение руки и сердца, большое торжество на вилле." },
    ],
  },
  en: {
    title: "How many roses to give — a quick cheat-sheet",
    subtitle: "The number of roses is a language. Here's how it's read.",
    cta: "Build a rose bouquet",
    cards: [
      { qty: "15–25", label: "A token", desc: "\"Just because\", a date, a dinner. A light, elegant gesture." },
      { qty: "51", label: "Romance", desc: "A declaration, anniversary, apology. The most popular size." },
      { qty: "101", label: "Grand gesture", desc: "Engagement, wedding anniversary, a big surprise." },
      { qty: "151+", label: "Wow effect", desc: "A marriage proposal, a large villa celebration." },
    ],
  },
  tr: {
    title: "Kac gul hediye edilir — hizli rehber",
    subtitle: "Gul sayisi bir dildir. Iste nasil okunur.",
    cta: "Gul buketi hazirla",
    cards: [
      { qty: "15–25", label: "Bir jest", desc: "\"Oylesine\", bir bulusma, bir aksam yemegi. Zarif bir jest." },
      { qty: "51", label: "Romantizm", desc: "Bir itiraf, yildonumu, ozur. En populer boyut." },
      { qty: "101", label: "Buyuk jest", desc: "Nisan, evlilik yildonumu, buyuk surpriz." },
      { qty: "151+", label: "Wow etkisi", desc: "Evlilik teklifi, villada buyuk kutlama." },
    ],
  },
};

const ICONS = [Heart, Sparkles, Gem, Crown];

export const RosesQuantityGuide = ({ lang = "ru", city, cityName }) => {
  const t = CONTENT[lang] || CONTENT.ru;
  const catalogTo = lang === "ru" ? `/${city}` : `/${city}?lang=${lang}`;

  return (
    <section className="mt-12 pt-8 border-t border-gray-100" data-testid="roses-quantity-guide">
      <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-1" style={{ fontFamily: "Playfair Display, serif" }}>
        {t.title}
      </h2>
      <p className="text-gray-500 text-sm sm:text-base mb-6">{t.subtitle}</p>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        {t.cards.map((card, i) => {
          const Icon = ICONS[i];
          return (
            <div
              key={card.qty}
              className="relative bg-gradient-to-br from-rose-50 to-pink-50 border border-pink-100 rounded-2xl p-4 sm:p-5 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:border-pink-300"
              data-testid={`roses-guide-card-${i}`}
            >
              <div className="flex items-center justify-between mb-3">
                <span className="text-3xl sm:text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-rose-500" style={{ fontFamily: "Playfair Display, serif" }}>
                  {card.qty}
                </span>
                <span className="w-9 h-9 rounded-full bg-white/70 flex items-center justify-center shadow-sm shrink-0">
                  <Icon className="w-4.5 h-4.5 text-rose-500" strokeWidth={1.75} />
                </span>
              </div>
              <div className="text-sm sm:text-base font-bold text-gray-900 mb-1">{card.label}</div>
              <p className="text-xs sm:text-sm text-gray-500 leading-snug">{card.desc}</p>
            </div>
          );
        })}
      </div>

      <div className="mt-5">
        <Link
          to={catalogTo}
          className="inline-flex items-center gap-2 bg-gradient-to-r from-pink-500 to-rose-500 text-white px-6 py-3 rounded-full font-bold hover:shadow-lg transition-all hover:scale-105"
          data-testid="roses-guide-cta"
        >
          {t.cta}
        </Link>
      </div>
    </section>
  );
};

export default RosesQuantityGuide;
